export default __webpack_public_path__ + "static/media/close.238b3bd3.svg";